import { useT } from "@/context/LanguageContext";
import { translations } from "@/data/translations";
import { motion } from "framer-motion";
import { Swords, Target, Flame, Shield, Dumbbell, Activity } from "lucide-react";

const disciplineIcons = [Swords, Target, Flame, Shield, Dumbbell, Activity];

export default function Disciplines() {
  const t = useT(translations.disciplines);

  return (
    <section
      id="disciplines"
      data-testid="disciplines-section"
      className="relative py-20 md:py-32"
    >
      <div className="absolute inset-0 bg-[#252b36]" />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-[0.3em] uppercase text-[#b87b56]">
            {t.caption}
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-white mt-3"
            style={{ fontFamily: "Oswald, sans-serif" }}
          >
            {t.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {t.items.map((item, i) => {
            const Icon = disciplineIcons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                data-testid={`discipline-card-${i}`}
                className="bg-[#39424F] border border-white/5 p-6 text-center hover:border-[#b87b56]/50 transition-all group"
              >
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center text-[#b87b56] group-hover:scale-110 transition-transform">
                  {Icon && <Icon size={28} strokeWidth={1.5} />}
                </div>
                <h3
                  className="text-sm font-bold text-white uppercase tracking-wider mb-1"
                  style={{ fontFamily: "Oswald, sans-serif" }}
                >
                  {item.name}
                </h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
